// "use client";

import { FormState, Results } from "./types";
import { IActions, IState } from "./interfaces";
import { PRODUCT_DATA } from "./constants";
import React, { useEffect, useState } from "react";

import CalculatorForm from "./calculator-form";
import ContactForm from "./contact-form";
import { ILanguageTranslations } from "./interfaces/languages";
import { PureFlocCalculatorProps } from "./purefloc-calculator.component";
import ResultsDisplay from "./results-display";
import { calculateResults } from "./utils";
import { useReactHookz } from "./state";

import styles from "./styles";

const initialForm: FormState = {
  product: "",
  application: "",
  surface: "",
  thickness: "",
};

export const Calculator = (props: PureFlocCalculatorProps) => {
  const [state]: [IState, IActions] = useReactHookz();
  const t = state.translations as ILanguageTranslations | undefined;

  const [form, setForm] = useState<FormState>(initialForm);
  const [results, setResults] = useState<Results>({});
  const [showContactForm, setShowContactForm] = useState(false);

  useEffect(() => {
    if (!document.getElementById("hs-script-loader")) {
      const script = document.createElement("script");
      script.src = "//js-na1.hs-scripts.com/27021741.js";
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";
      document.body.appendChild(script);
    }
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { id, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [id]: value,
      ...(id === "product" && { application: "" }),
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { product, application, surface, thickness } = form;
    const data = PRODUCT_DATA[product]?.[application];

    if (!data || !surface || !thickness) {
      setResults({ error: t?.invalidInput });
      setShowContactForm(false);
      return;
    }

    const surfaceNum = parseFloat(surface);
    const thicknessNum = parseFloat(thickness);

    const res = calculateResults(
      data,
      surfaceNum,
      thicknessNum,
      product,
      data.shouldRoundThickness ?? false
    );

    setResults(res);
    setShowContactForm(true);
  };

  return (
    <section style={styles.calculator}>
      <CalculatorForm
        form={form}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
      <ResultsDisplay results={results} />
      {showContactForm && <ContactForm results={results} />}
    </section>
  );
};

export default Calculator;
